import { canonicalizeCountryCode } from "@/constants/billingCatalog"
import { countryParamPresent } from "../landingCountryDetect"
import { landingMarket } from "../landingMarket"
import { testDriveAddressForCountry } from "./testDriveAddress"

export { TEST_DRIVE_ADDRESS } from "./testDriveAddress"

export function leadCountryForTestDrive(search, detectedCountry) {
  if (countryParamPresent(search)) {
    const params = typeof search === "string" ? new URLSearchParams(search) : search
    return canonicalizeCountryCode(params?.get?.("country"))
  }
  return canonicalizeCountryCode(detectedCountry)
}

export const TEST_DRIVE_BOT = "Roofing"
export const TEST_DRIVE_SERVICE = "Roof Replacement"

const TRACKING_KEYS = [
  "gclid", "fbclid", "utm_source", "utm_medium", "utm_campaign",
  "utm_term", "utm_content", "gbraid", "wbraid",
]

function trackingFrom(search) {
  const params = typeof search === "string" ? new URLSearchParams(search) : search
  const read = params?.get
  const fields = {}
  for (const key of TRACKING_KEYS) {
    if (typeof read !== "function") {
      fields[key] = ""
      continue
    }
    const value = read.call(params, key)
    fields[key] = value == null || value === "" ? "" : value
  }
  return fields
}

function trimmedText(value) {
  return typeof value === "string" ? value.trim() : ""
}

export function buildTestDriveLead({ name, phone, email, country, pageUrl, search }) {
  const nextName = trimmedText(name)
  const nextPhone = trimmedText(phone)
  const nextEmail = trimmedText(email)
  const pageText = typeof pageUrl === "string" ? pageUrl.trim() : ""
  if (!nextName || !nextPhone || !nextEmail || typeof country !== "string" || !pageText) {
    return null
  }
  return {
    name: nextName,
    phone: nextPhone,
    email: nextEmail,
    country,
    tested_bot: TEST_DRIVE_BOT,
    address: testDriveAddressForCountry(country, landingMarket(country)),
    service_required: TEST_DRIVE_SERVICE,
    current_url_page: pageUrl,
    ...trackingFrom(search),
  }
}
